export const createUnsavedChangesBlockerSlice = (set, get) => ({
  isDataChanged: false,
  setGlobalIsDataChanged: (value) => set({ isDataChanged: value }),

  onGlobalApplyFn: null,
  setGlobalOnApplyFn: (func) => set(() => ({ onGlobalApplyFn: func })),

  onGlobalDiscardFn: null,
  setGlobalOnDiscardFn: (func) => set(() => ({ onGlobalDiscardFn: func })),
});
